export default __webpack_public_path__ + "static/media/me3_Laptop.fa8c65d0.svg";